export const environment = {
    production: false,
    currentData: 'https://results-display-current-uat.azurewebsites.net/',
    appInsights: {
        instrumentationKey: '16356126-dba5-4ef9-ae65-10166b86e5a8'
    },
    isMock: false
};
